import React, { Component } from "react";
import DataTable from "react-data-table-component";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
import Time from "react-time-format";
import _ from "lodash";
import { Get_List_Bills } from "../../actions/Invoice_action";
class PrintListTakeMoney extends Component {
  componentDidMount() {
    this.props.Get_List_Bills();
  }
  render() {
    const { lang, change_Lang, list_bills, primary_logo } = this.props;
    const params = this.props.match.params.type;
    const params_status = this.props.match.params.status;
    const datas = list_bills
      .filter((data) => {
        if (data.status !== "delete") {
          if (params === "Monthly rent invoice") {
            return data.type === "Monthly rent invoice";
          } else if (params === "Service Bill") {
            return data.type === "Service Bill";
          } else if (params === "Insurance Bill") {
            return data.type === "Insurance Bill";
          } else if (params === "Sell") {
            return data.type === "Sell";
          } else if (params === "Arabun") {
            return data.type === "Arabun";
          } else if (params === "Buy") {
            return data.type === "Buy";
          } else if (params === "comision") {
            return data.type === "comision";
          } else if (params === "investor") {
            return data.type === "investor";
          } else if (params_status === "off") {
            return data.box_status === "off";
          } else if (params_status === "investor") {
            return data.box_status === "on";
          } else if (params_status === "all") {
            return data.box_status;
          } else if (params === "all") {
            return data.type;
          } else {
            return data;
          }
        }
      })
      .filter((el) => {
        if (params_status !== "all" && params !== "all") {
          return el.box_status === params_status && el.type === params;
        } else {
          return el;
        }
      })
      .map((el, i) => {
        return {
          id: i + 1,
          firstName: (
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.Money_provider}
            </span>
          ),
          branch: (
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.branchId.name}
            </span>
          ),
          currency: (
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {change_Lang(el.currency)}
            </span>
          ),
          user: (
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.Money_recive}
            </span>
          ),
          type: (
            <span
              className={`${lang === "en" ? "font-weight-bold" : "fk"}`}
              style={{
                fontWeight: "bolder",
                color: `${
                  el.type === "Monthly fee receipts"
                    ? "#295a68"
                    : el.type === "Service Bill"
                    ? "#295a68"
                    : "#295a68"
                }`,
              }}
            >
              {change_Lang(el.type)}
            </span>
          ),
          lastPrice: (
            <NumberFormat
              displayType="text"
              thousandSeparator={true}
              value={el.Amount}
              className={`${lang === "en" ? "" : "fk"}`}
              prefix={el.currency !== "dolar" ? " ID" : " $"}
            />
          ),
          box_status: (
            <span
              className={`${lang === "en" ? "" : "fk"}`}
              style={{
                color: el.box_status !== "off" ? "#295a68" : "black",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {change_Lang(el.box_status)}
            </span>
          ),
          date: (
            <Time
              value={el.createdAt}
              format="YYYY-MM-DD"
              style={{ color: "black" }}
              className={`${lang === "en" ? "" : "fk"}`}
            />
          ),
        };
      });
    const columns = [
      {
        name: change_Lang("id"),
        selector: "id",
        center: true,
        compact: true,
      },
      {
        name: change_Lang("received from Mr"),
        selector: "firstName",
        center: true,
        compact: true,
      },
      {
        name: change_Lang("Name of Branch"),
        selector: "branch",
        center: true,
        compact: true,
      },
      {
        name: change_Lang("type"),
        selector: "type",
        center: true,
        compact: true,
      },
      {
        name: change_Lang("pr_price"),
        selector: "lastPrice",
        center: true,
        compact: true,
      },
      {
        name: change_Lang("Go to the box."),
        selector: "box_status",
        center: true,
        compact: true,
        width: "100px",
      },
      {
        name: change_Lang("User"),
        selector: "user",
        center: true,
        compact: true,
      },
      {
        name: change_Lang("date"),
        selector: "date",
        center: true,
        compact: true,
      },
    ];
    const customStyles = {
      header: {
        style: {
          minHeight: "0.1px",
          background: "#e3e9f2",
        },
      },
      headRow: {
        style: {
          borderTopStyle: "solid",
          borderTopWidth: "1px",
          background: "#e3e9f2",
        },
      },
      headCells: {
        style: {
          color: "black",
          fontSize: "14px",
        },
      },
    };
    const Total = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "comision" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "comision" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Rent = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Monthly rent invoice" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "Monthly rent invoice" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Sell = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Sell" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "Sell" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Service = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Service Bill" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "Service Bill" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Buy = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Buy" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "Buy" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Arabun = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Arabun" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "Arabun" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_sayfty = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Insurance Bill" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "Insurance Bill" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Investor_Dolar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "investor" &&
              o.currency === "dolar" &&
              o.box_status === params_status
            : o.type === "investor" && o.currency === "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Tow_One = _.add(Total, Total_Investor_Dolar);
    const Tow_Two = _.add(Total_Rent, Total_Sell);
    const Tow_Three = _.add(Total_Service, Total_Buy);
    const Tow_Four = _.add(Total_Arabun, Total_sayfty);
    const Tow_Five = _.add(Tow_One, Tow_Two);
    const Tow_Six = _.add(Tow_Three, Tow_Four);
    const Tow_Seven = _.add(Tow_Five, Tow_Six);
    const Total_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "comision" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "comision" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Rent_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Monthly rent invoice" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "Monthly rent invoice" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Sell_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Sell" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "Sell" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Service_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Service Bill" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "Service Bill" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Buy_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Buy" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "Buy" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Arabun_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Arabun" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "Arabun" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_sayfty_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "Insurance Bill" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "Insurance Bill" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Total_Investor_Dinar = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (
          params_status
            ? o.type === "investor" &&
              o.currency !== "dolar" &&
              o.box_status === params_status
            : o.type === "investor" && o.currency !== "dolar"
        ) {
          return Number(o.Amount);
        } else {
          return 0;
        }
      }
    });
    const Tow_One_Dinar = _.add(Total_Dinar, Total_Investor_Dinar);
    const Tow_Two_Dinar = _.add(Total_Rent_Dinar, Total_Sell_Dinar);
    const Tow_Three_Dinar = _.add(Total_Service_Dinar, Total_Buy_Dinar);
    const Tow_Four_Dinar = _.add(Total_Arabun_Dinar, Total_sayfty_Dinar);
    const Tow_Five_Dinar = _.add(Tow_One_Dinar, Tow_Two_Dinar);
    const Tow_Six_Dinar = _.add(Tow_Three_Dinar, Tow_Four_Dinar);
    const Tow_Seven_Dinar = _.add(Tow_Five_Dinar, Tow_Six_Dinar);
    const Total_Params_$ = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (o.type === params && o.currency === "dolar") {
          return o.Amount;
        } else {
          return 0;
        }
      }
    });
    const Total_Params_ID = _.sumBy(list_bills, function (o) {
      if (o.status !== "delete") {
        if (o.type === params && o.currency !== "dolar") {
          return o.Amount;
        } else {
          return 0;
        }
      }
    });
    return (
      <>
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk "
          }`}
        >
          <div className="row content-containers">
            <div className="col-12">
              <div className="card product-page-main card-body">
                <div className="card-body p-0" id="yy">
                  <div class="row">
                    <div class="col-md-12  ">
                      <img
                        src={primary_logo}
                        alt="logo"
                        className="img-fluid img-responsive"
                        style={{
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12">
                      <div className=" text-center" style={{ background: "" }}>
                        <h3 style={{ fontWeight: "bold", color: "black" }}>
                          {change_Lang("list taking money")}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <DataTable
                      striped
                      className="fk col-12"
                      customStyles={customStyles}
                      columns={columns}
                      data={datas}
                      noDataComponent={change_Lang("table_display")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {params !== "all" ? (
            <div class="container">
              <ul class="responsive-table">
                <li class="table-header">
                  <div class="col d-flex justify-content-center">
                    {change_Lang(params)} بە $
                  </div>
                  <div class="col d-flex justify-content-center">
                    {change_Lang(params)} بە دینار
                  </div>
                </li>
                <td></td>
                <li class="table-row">
                  <div
                    class="col d-flex justify-content-center"
                    data-label="Job Id"
                  >
                    <NumberFormat
                      displayType="text"
                      thousandSeparator={true}
                      value={Total_Params_$}
                      className={`${lang === "en" ? "" : "fk"}`}
                      prefix="$"
                      style={{
                        border: "2px solid #295a68",
                        fontWeight: "bolder",
                        color: "black",
                      }}
                    />
                  </div>
                  <div
                    class="col d-flex justify-content-center"
                    data-label="Job Id"
                  >
                    <NumberFormat
                      displayType="text"
                      thousandSeparator={true}
                      value={Total_Params_ID}
                      className={`${lang === "en" ? "" : "fk"}`}
                      prefix="IQD"
                      style={{
                        border: "2px solid #295a68",
                        fontWeight: "bolder",
                        color: "black",
                      }}
                    />
                  </div>
                </li>
              </ul>
            </div>
          ) : (
            <>
              <div class="container">
                <ul class="responsive-table">
                  <li class="table-header">
                    <div class="col d-flex justify-content-center">کرێ $</div>
                    <div class="col d-flex justify-content-center">
                      خزمەتگوزاری$
                    </div>
                    <div class="col d-flex justify-content-center">
                      دڵنیایی$
                    </div>
                    <div class="col d-flex justify-content-center">فرۆشتن$</div>
                    <div class="col d-flex justify-content-center">کڕین$</div>
                    <div class="col d-flex justify-content-center">عربون$</div>
                    <div class="col d-flex justify-content-center">عمولە$</div>
                    <div class="col d-flex justify-content-center">
                      وەبەرهێنەر$
                    </div>
                    <div class="col d-flex justify-content-center">
                      کۆی پارە$
                    </div>
                  </li>
                  <td></td>
                  <li class="table-row">
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Rent}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Service}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_sayfty}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Sell}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Buy}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Arabun}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Customer Name"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Investor_Dolar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                        style={{ color: "black" }}
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Customer Name"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Tow_Seven}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="$"
                        style={{ color: "black" }}
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <div class="container">
                <ul class="responsive-table">
                  <li class="table-header">
                    <div class="col d-flex justify-content-center">کرێ ID</div>
                    <div class="col d-flex justify-content-center">
                      خزمەتگوزاریID
                    </div>
                    <div class="col d-flex justify-content-center">
                      دڵنیاییID
                    </div>
                    <div class="col d-flex justify-content-center">
                      فرۆشتنID
                    </div>
                    <div class="col d-flex justify-content-center">کڕینID</div>
                    <div class="col d-flex justify-content-center">عربونID</div>
                    <div class="col d-flex justify-content-center">عمولەID</div>
                    <div class="col d-flex justify-content-center">
                      وەبەرهێنەرID
                    </div>
                    <div class="col d-flex justify-content-center">
                      کۆی پارەID
                    </div>
                  </li>
                  <td></td>
                  <li class="table-row">
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Rent_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Service_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_sayfty_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Sell_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Buy_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Arabun_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Total_Investor_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                    <div
                      class="col d-flex justify-content-center"
                      data-label="Job Id"
                    >
                      <NumberFormat
                        displayType="text"
                        thousandSeparator={true}
                        value={Tow_Seven_Dinar}
                        className={`${lang === "en" ? "" : "fk"}`}
                        prefix="IQD"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    list_bills: state.InvoiceReducer.list_bills,
    primary_logo: state.HelperReducer.primary_logo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    Get_List_Bills: () => dispatch(Get_List_Bills()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintListTakeMoney);
